export default [
	{
		title: "Default",
		thumb: require("../assets/themes/dark-tn.jpg"),
		color: "#1D1D1B",
	},
];
